module.exports = __webpack_public_path__ + "img/Pattern03.dec842df.png";